import * as React from 'react';
import { default as LoginWithToken } from '../containers/LoginWithToken';

export class LoginWithTokenView extends React.Component<{}, {}> {
  render() {
    return (
       <LoginWithToken />
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/LoginWithTokenView.tsx